export const MOON_ID = "301"

function isSpacecraft(name: string, kind?: string): boolean {
  if (kind !== "MB") return false

  const spacecraftPatterns = [
    /voyager/i,
    /cassini/i,
    /juno/i,
    /perseverance/i,
    /curiosity/i,
    /opportunity/i,
    /spirit/i,
    /new horizons/i,
    /parker solar probe/i,
    /james webb/i,
    /hubble/i,
  ]

  return spacecraftPatterns.some(pattern => pattern.test(name))
}

export function getEmojiForKind(kind?: string, name?: string): string {
  if (!kind) return "⭐"

  // SIMBAD/Sesame STAR/DSO kinds (do not use the scope symbol)
  switch (kind) {
    case "STAR":
      return "⭐"
    case "STAR_MULT":
      return "👯"
    case "STAR_VAR":
      return "✨" // per preference: 3-star for variable stars
    case "DSO_ASTERISM":
      return "✨" // per preference: 3-star for asterisms
    case "DSO_GALAXY":
      return "🌌"
    case "DSO_NEBULA":
      return "🫧"
    case "DSO_PN":
      return "🟢"
    case "DSO_OPEN_CLUSTER":
      return "✨"
    case "DSO_GLOBULAR_CLUSTER":
      return "🟡"
    case "DSO_DARK_NEBULA":
      return "⚫"
    case "DSO_REFLECTION_NEBULA":
      return "🔵"
    case "DSO_SNR":
      return "💥"
    case "DSO_MOL_CLOUD":
      return "☁️"
    case "DSO_GALAXY_CLUSTER":
      return "🏙️"
  }

  // Check if it's a spacecraft first
  if (name && isSpacecraft(name, kind)) {
    return "🛰️" // Satellite for spacecraft
  }

  // Check for specific solar system objects by name
  if (name && kind === "MB") {
    const normalizedName = name.toLowerCase().trim()

    // Moon (Earth's moon)
    if (
      normalizedName === "moon" ||
      normalizedName === "luna" ||
      /\b(moon|luna)\b/.test(normalizedName)
    )
      return "🌙"

    // Sun
    if (normalizedName === "sun") return "☀️"

    // Planets
    if (normalizedName === "mercury") return "🟠"
    if (normalizedName === "venus") return "⚪"
    if (normalizedName === "earth") return "🌍"
    if (normalizedName === "mars") return "🔴"
    if (normalizedName === "jupiter") return "🟠"
    if (normalizedName === "saturn") return "🪐"
    if (normalizedName === "uranus") return "🔵"
    if (normalizedName === "neptune") return "🔵"
    if (normalizedName === "pluto") return "🟣"
  }

  // Fallback to kind-based icons
  switch (kind) {
    case "SB": // Small body (asteroids, comets)
      return "☄️"
    case "MB": // Major body (planets, moons, spacecraft)
      return "🔵"
    default:
      return "⭐"
  }
}
